import { type ReactNode } from 'react';
import { RefreshCw } from 'lucide-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';
import type { EnrichedMember } from '../types';

function useRefreshPhoto() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (id: string) =>
      pb.send(`/api/team-members/refresh-photo/${id}`, { method: 'POST' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['team-members-admin'] });
      toast('Foto actualizada', 'success');
    },
    onError: () => toast('Error al refrescar foto', 'error'),
  });
}

export function RowActions({ member }: { member: EnrichedMember }): ReactNode {
  const refresh = useRefreshPhoto();
  return (
    <div className="flex items-center gap-xs">
      <button
        onClick={() => refresh.mutate(member.id)}
        disabled={refresh.isPending}
        className="rounded p-1 text-text-tertiary transition-colors hover:text-text-primary disabled:opacity-30"
        title="Refrescar foto IG"
      >
        <RefreshCw size={13} />
      </button>
    </div>
  );
}
